import { createPortal } from 'react-dom';

export default function ToastPortal({ toast, onClose }) {
  if (!toast || typeof document === 'undefined') return null;

  return createPortal(
    <div
      className={`fixed left-1/2 top-6 z-[9999] max-w-[min(92vw,520px)] -translate-x-1/2 rounded-lg px-4 py-3 text-sm font-medium text-white shadow-2xl ${
        toast.type === 'error' ? 'bg-red-600' : 'bg-[#2e7d32]'
      }`}
      role="alert"
      aria-live="assertive"
    >
      <div className="flex items-start justify-between gap-3">
        <span>{toast.message}</span>
        <button type="button" onClick={onClose} className="shrink-0 underline">
          Dismiss
        </button>
      </div>
    </div>,
    document.body
  );
}
